import { BaseControl } from "../base-control";

class UrlControlCtrl extends BaseControl {
  constructor(BaseControlService, $scope) {
    'ngInject';
    super(BaseControlService, $scope);
  }

  getMaxLength() {
    return this.token.control.maxLength;
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/url-control/url-control.component.html",
  controller: UrlControlCtrl
};